  <app-navbar >
      <div class="container-fluid custom-bg">
       <div class="row m-0 p-4">
         <div class="col-sm-0 col-md-0 p-1 col-lg-6">
           <div class="p-2">
            <ul class="nav nav-tabs mb-3 d-flex flex-sm-wrap" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link p-4 col-sm-12"
                  id="garantiaOrdinaria"
                  (click)="showOrdinaria = true"
                  >Sobre a Garantia Ordinária</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link p-4 col-sm-12"
                  id="garantiaEspecial"
                  (click)="showOrdinaria = false"
                  >Sobre a Garantia Especial - DPGE</a
                >
              </li>
            </ul>
            <div class="tab-content" *ngIf="showOrdinaria" id="garantiaOrdinaria">
              <div class="row p-1">
                <h3 class="title-page mt-2">Garantia Ordinária</h3>
              </div>
              <div class="row p-1">
                <h3 class="small-title">Sobre a Garantia</h3>
              </div>
              <div class="row p-1">
                <p class="info-text mt-4">
                  Fazem parte da garantia ordinária proporcionada pelo FGC os seguintes créditos:
                </p>
                <ul class="info-text">
                  <li>Depósitos de poupança;</li>
               <li>Depósitos à vista ou sacáveis mediante aviso prévio;</li>
               <li>Depósitos a prazo, com ou sem emissão de certificado RDB (Recibo de Depósito Bancário) e CDB (Certificado de Depósito Bancário);</li>
               <li>Entre outros.</li>
              </ul>
              <p class="info-text">Para saber mais sobre os depósitos e instrumentos financeiros garantidos pelo FGC acesse a página <a href="https://www.fgc.org.br/sobre-garantia-fgc" target="_blank"> SOBRE A GARANTIA DO FGC. </a></p>
            </div>
            </div>

            <div class="tab-content" *ngIf="!(showOrdinaria)" id="garantiaEspecial">
              <div class="row p-1">
                <h3 class="title-page mt-2">Garantia Especial (DPGE)</h3>
              </div>
              <div class="row p-1">
                <h3 class="small-title">Sobre a Garantia</h3>
              </div>
              <div class="row p-1">
                <p class="info-text mt-4">
                  O FGC também presta garantia especial aos depositantes e investidores que detêm o Depósito a Prazo com Garantia Especial – DPGE,
                  sendo uma modalidade de depósito especial criada pelo conselho Monetário nacional. Importante observar que a identificação de que se trata de um depósito
                  deve estar especificado no contrato firmado e/ou nota de negociação emitida pela instituição financeira, sendo
                   que as aplicações em DPGE somente podem ser celebradas com um único titular, a ser identificado pelo respectivo
                   número do CPF/CNPJ, ou seja, não pode ser vinculado a conta conjunta.
                </p>
              <p class="info-text">Para saber mais sobre os depósitos e instrumentos financeiros garantidos pelo FGC acesse a página <a href="https://www.fgc.org.br/sobre-garantia-fgc" target="_blank"> SOBRE A GARANTIA DO FGC. </a></p>
            </div>
            </div>
          </div>
        </div>
        <div class="col-sm-0 col-md-12 p-4 col-lg-6">
          <div class="row">
            <h4 class="title-regime-especial text-left">
              Instituições em Regime Especial
            </h4>
            </div>
            <div class="row p-sm-5">
              <div *ngFor="let card of tableDataCard | paginate: {itemsPerPage: 2, currentPage: p}"
              class="card col-sm-12 m-1 col-md-12 p-5 d-flex flex-wrap align-items-start align-items-sm-center text-left card-regime-especial">
              <h3 class="card-title">{{card.nomeInstituicaoFinanceira}}</h3>
              <span class="btn-liquidacao p-2">Liquidação: {{card.dataLiquidacao | date: 'dd/MM/yyyy'}}</span>
            </div>
          </div>
          <div *ngIf="tableDataCard.length == 0" class="row my-3 mx-5">
            <div class="card card-regime-especial">
              <h3 class="card-title p-4">Nenhuma instituição financeira encontrada em regime especial.</h3>
               </div>
          </div>
              <pagination-controls
              *ngIf="tableDataCard.length >= 2"
              class="d-flex justify-content-center"
              responsive="true"
              (pageChange)="p = $event"
              previousLabel="Voltar"
              nextLabel="Próxima"
              ></pagination-controls>
            </div>
          </div>
        </div>


        <div class="container-fluid">
          <div class="container d-flex align-center text-center mb-5">
            <div class="col-12 mt-5 mb-5">
          <h3 class="news-title mb-5 pt-5 pb-5">Notícias</h3>
          <div class="row mt-5">
            <div class="d-flex flex-wrap">
              <div class="col-sm-12 col-md-4 col-lg-4">
                <a href="https://www.fgc.org.br/quem-somos" target="_blank">
                  <div class="card card-news">
                    <img class="card-img-top" src="../../../../assets/images/quem-somos.png" alt="quem_somos_fgc">
                    <div class="card-body">
                      <h5 class="card-title-news">Quem Somos</h5>
                      <p class="card-text text-left">FGC.</p>
                    </div>
                  </div>
                </a>
                </div>
                <div class="col-sm-12 col-md-4 col-lg-4">
                  <a href="https://www.fgc.org.br/quem-somos" target="_blank">
                    <div class="card card-news">
                      <img class="card-img-top" src="../../../../assets/images/codigo-etica.png" alt="quem_somos_fgc">
                      <div class="card-body">
                        <h5 class="card-title-news">Código de ética e conduta</h5>
                        <p class="card-text text-left">FGC.</p>
                      </div>
                    </div>
                  </a>
                </div>
                <div class="col-sm-12 col-md-4 col-lg-4">
                  <a href="https://www.fgc.org.br/instituicoes-associadas-e-conglomerados" target="_blank">
                    <div class="card card-news">
                      <img class="card-img-top" src="../../../../assets/images/instituicoes-associadas.png" alt="quem_somos_fgc">
                      <div class="card-body">
                        <h5 class="card-title-news">Lista de instituições associadas</h5>
                        <p class="card-text text-left">FGC.</p>
                      </div>
                    </div>
                  </a>
                </div>
            </div>
            </div>
              <div class="row mt-5">
                <div class="col-sm-12 col-md-4 col-lg-4">
                    <a href="https://www.fgc.org.br/pagamento-de-garantia" target="_blank">
                      <div class="card card-news">
                        <img class="card-img-top" src="../../../../assets/images/pagamento-garantia.png" alt="quem_somos_fgc">
                        <div class="card-body">
                          <h5 class="card-title-news">Pagamento de Garantia</h5>
                          <p class="card-text text-left">FGC.</p>
                        </div>
                      </div>
                    </a>
                    </div>
                    <div class="col-sm-12 col-md-4 col-lg-4">
                      <a href="https://www.fgc.org.br/faq" target="_blank">
                        <div class="card ">
                          <img class="card-img-top" src="../../../../assets/images/perguntas-respostas.png" alt="quem_somos_fgc">
                          <div class="card-body">
                            <h5 class="card-title-news">Perguntas e Respostas sobre a garantia</h5>
                            <p class="card-text text-left">FGC.</p>
                          </div>
                        </div>
                      </a>
                    </div>
                    <div class="col-sm-12 col-md-4 col-lg-4">
                      <a href="https://www.fgc.org.br/sobre-garantia-fgc" target="_blank">
                        <div class="card card-news">
                          <img class="card-img-top" src="../../../../assets/images/pagamento-garantia.png" alt="quem_somos_fgc">
                          <div class="card-body">
                            <h5 class="card-title-news">Informações sobre o teto de 1 milhão</h5>
                            <p class="card-text text-left">FGC.</p>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
        </div>

        </div>
      </div>
    <app-footer class="mt-5"></app-footer>
  </app-navbar>
